import { useProduct } from '@gemini-vsf/composables';
import { productData } from '~/helpers/product/productData';
import { ref } from '@nuxtjs/composition-api';
import { flattenDeep } from 'lodash';

const useProductSearch = () => {
  const { cacheId } = productData();
  const { search: searchProducts, products: searchResult, error, loading } = useProduct(cacheId);
  const product = ref(null);
  const getProductById = async (id: string, productConfiguration, customQuery?) => {
    const baseSearchQuery = {
      filter: {
        uid: id,
      },
      ...(productConfiguration?.value?.length > 0
        ? {
            configurations: productConfiguration.value.map((config) => config[1]),
          }
        : {}),
    };

    await searchProducts({
      queryType: 'DETAIL',
      ...baseSearchQuery,
      customQuery: {
        productDetail: customQuery,
      },
    });
    product.value = searchResult?.value?.items?.[0] || null;
  };

  const getProductWithVariant = async (id: string, label: string, value: string, productConfiguration, customQuery?) => {
    const newConfiguration = flattenDeep([...productConfiguration, [label, value]]).filter((c: string) => {
      if (!c.includes(':')) return false;
      const [newOptionName, newOptionValue] = value.split(':');
      const [oldOptionName, oldOptionValue] = c.split(':');
      if (newOptionName !== oldOptionName) return true;
      return !(oldOptionValue !== newOptionValue);
    });
    const baseSearchQuery = {
      filter: {
        uid: id,
      },
      ...(newConfiguration.length > 0
        ? {
            configurableOptionValueUids: newConfiguration,
          }
        : {}),
    };

    await searchProducts({
      queryType: 'DETAIL',
      ...baseSearchQuery,
      customQuery: {
        productDetail: customQuery,
      },
    });

    product.value = searchResult?.value?.items?.[0] || null;

    return newConfiguration;
  };

  const getSpecificVariant = async (uid: string, configurableOptionValueUids: [string], customQuery?) => {
    await searchProducts({
      queryType: 'DETAIL',
      filter: {
        uid,
      },
      configurableOptionValueUids,
      customQuery: {
        productDetail: customQuery,
      },
    });

    product.value = searchResult?.value?.items?.[0] || null;
  };

  return {
    getProductById,
    product,
    getProductWithVariant,
    error,
    getSpecificVariant,
    loading,
  };
};

export default useProductSearch;
